import { nightOpsProfile } from '../themeProfiles/nightOps';

// Night Ops Theme - Dark theme with blue accents (like HomePage)
export const nightOpsTheme = {
  name: 'nightOps',
  colors: {
    primary: '#00d4ff',
    primaryDark: '#00a8ff',
    secondary: '#8bb8d8',
    background: '#03070f',
    backgroundSecondary: 'rgba(3, 7, 15, 0.95)',
    surface: '#0c1e2f',
    surfaceHover: '#132e45',
    text: '#f4fbff',
    textSecondary: '#d0e4ff',
    textMuted: '#8da1bf',
    textDisabled: '#657086',
    border: 'rgba(0, 212, 255, 0.55)',
    borderLight: 'rgba(0, 212, 255, 0.35)',
    borderMuted: 'rgba(0, 212, 255, 0.15)',
    error: '#ff5467',
    success: '#00ff88',
    warning: '#ffaa00',
  },
  fonts: {
    body: "'Courier New', monospace",
    heading: "'Rajdhani', sans-serif",
  },
  gradients: {
    background: 'radial-gradient(ellipse at center, #032238 0%, #020a13 70%, #000204 100%)',
    surface: 'linear-gradient(135deg, rgba(0, 212, 255, 0.18) 0%, transparent 55%)',
    primary: 'linear-gradient(135deg, #00d4ff, #00a8ff)',
    glow: 'radial-gradient(circle at 20% 50%, rgba(0, 212, 255, 0.25) 0%, transparent 60%)',
  },
  shadows: {
    primary: '0 0 18px rgba(0, 212, 255, 0.6)',
    card: '0 18px 32px rgba(1, 12, 20, 0.75)',
    button: '0 0 20px rgba(0, 212, 255, 0.45)',
  },
  animatedBackground: {
    gridColor: 'rgba(0, 212, 255, 0.12)',
    circleColor: '#00d4ff',
    scanlineColor: '#00d4ff',
  },
  styles: {
    cardBorderRadius: '16px',
    cardBackdrop: 'blur(12px)',
    buttonBorderRadius: '10px',
    headerBackground: 'rgba(3, 10, 22, 0.9)',
    headerBorder: 'rgba(0, 212, 255, 0.25)',
  },
  profile: nightOpsProfile,
};
